import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { LocationFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface LocationFormProps {
  defaultFormValues?: Partial<LocationFormValues>;
  children?: React.ReactNode;
}
export const LocationForm = ({
  defaultFormValues,
  children,
}: LocationFormProps) => {
  const methods = useForm<LocationFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
